import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/extensions', { params });
  },
  view(id) {
    return Backend.get(`/extensions/${id}`);
  },
  update(id, data) {
    return Backend.put(`/extensions/${id}`, data);
  }
};
